import type { RouteRecordRaw } from 'vue-router';

/**
 * Demo Routes
 *
 * Routes for the PrimeVue component demonstration pages.
 * Showcases all available components with interactive examples.
 */

const demoRoutes: RouteRecordRaw[] = [
  {
    path: '/demo',
    name: 'demo',
    component: () => import('@/views/DemoView.vue'),
    meta: {
      title: 'Component Demo',
    },
    children: [
      {
        path: 'data',
        name: 'demo-data',
        component: () => import('@/views/demo/DataDisplayDemo.vue'),
        meta: {
          title: 'Data Display Components',
        },
      },
      {
        path: 'forms',
        name: 'demo-forms',
        component: () => import('@/views/demo/FormsDemo.vue'),
        meta: {
          title: 'Form Components',
        },
      },
      {
        path: 'feedback',
        name: 'demo-feedback',
        component: () => import('@/views/demo/FeedbackDemo.vue'),
        meta: {
          title: 'Feedback Components',
        },
      },
      {
        path: 'dialogs',
        name: 'demo-dialogs',
        component: () => import('@/views/demo/DialogsDemo.vue'),
        meta: {
          title: 'Dialog Components',
        },
      },
      {
        path: 'layout',
        name: 'demo-layout',
        component: () => import('@/views/demo/LayoutDemo.vue'),
        meta: {
          title: 'Layout Components',
        },
      },
      {
        path: 'buttons',
        name: 'demo-buttons',
        component: () => import('@/views/demo/ButtonsDemo.vue'),
        meta: {
          title: 'Button Components',
        },
      },
    ],
  },
];

export default demoRoutes;
